import React, { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { authSession } from "../lib/api";
import { ARIA } from "../lib/assets";

export default function AuthCallback() {
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { window.location.href = "/"; return; }
      try {
        await authSession(sessionId);
        window.history.replaceState({}, document.title, "/");
        window.location.href = "/";
      } catch (e) {
        if (e.message === "not-authorized") {
          setError("This account is not authorized to access ARIA.");
        } else {
          setError("Sign-in failed. Please try again.");
        }
        setTimeout(() => (window.location.href = "/"), 2600);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0908] flex items-center justify-center">
      <div className="text-center fade-up">
        <img src={ARIA.portrait} alt="Aria" className="w-16 h-16 rounded-full object-cover mx-auto border border-amber-400/40" />
        <div className="mt-4 flex items-center gap-2 text-amber-300 justify-center">
          {!error ? (<><Loader2 className="animate-spin" size={16} /> Signing you in…</>) : <span className="text-rose-400">{error}</span>}
        </div>
      </div>
    </div>
  );
}
